import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from "./i18n/i18n";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import 'amfe-flexible/index.js';
import VueClipboard from 'vue-clipboard2';
import 'animate.css';
// import bus from '@/assets/js/bus';
// import Web3 from 'web3';
import bus from '@/assets/js/bus';
import "swiper/swiper-bundle.min.css";

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole();
// Vue.use(vConsole);

Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.use(ElementUI, {size: 'small'});

import globalBase from './global_base';
Vue.use(globalBase);
import globalWallet from './global_wallet_bsc';
Vue.use(globalWallet);


new Vue({i18n,router,store,render: h => h(App)}).$mount('#app');


  



